<template>
  <div class="main-section-container">
    <div class="main-section-s1">
      <div class="main-section-s1-text-con">
        <router-link
          to=""
          v-scroll-to="{
            el: '#footer',
            duration: 2000,
            easing: 'ease-in'
          }"
          name="talktous"
          :style="$i18n.locale === 'en' ? 'letter-spacing: 2px;' : ''"
          >{{ $t("talktous") }}</router-link
        >
        <div class="wow fadeIn delay-1s">
          <ul>
            <li>
              <a
                :href="contactusInfo.sm.fb"
                target="_blank"
                style="margin-left: -22px;"
              >
                <font-awesome-icon
                  :icon="['fab', 'facebook-square']"
                  size="2x"
                  color="#cedb2d"
                />
              </a>
            </li>
            <li>
              <a
                :href="contactusInfo.sm.in"
                target="_blank"
                style="display: block; padding-top: 20px; margin-left: -22px;"
              >
                <font-awesome-icon
                  :icon="['fab', 'instagram']"
                  size="2x"
                  color="#cedb2d"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main-section-s2">
      <div
        :class="
          $i18n.locale === 'en'
            ? 'en-center main-section-s2-con'
            : 'ku-center main-section-s2-con'
        "
      >
        <div class="wow fadeInDown main-section-s2-title-con">
          <h1>{{ $t("doLess.") }}</h1>
          <h1>{{ $t("getMore.") }}</h1>
        </div>
        <p class="wow fadeInUp">
          {{ aboutInfo[getIndex()] }}
        </p>
        <div class="main-section-s2-scrollcon wow fadeInUp delay-1s">
          <router-link
            to=""
            v-scroll-to="{
              el: '#services',
              duration: 800,
              easing: 'ease-in'
            }"
            class="round"
            style="color: white;"
          >
            {{ $t("services") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomeMainSection",
  computed: mapGetters(["aboutInfo", "contactusInfo"]),
  methods: {
    getIndex() {
      if (this.$i18n.locale === "ku") return 0;
      else if (this.$i18n.locale === "ar") return 1;
      else return 2;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-section-container {
  width: 100%;
  height: 100vh;
  padding-top: 10vh;
  // background-color: rebeccapurple;
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.main-section-s1 {
  // background-color: palevioletred;
  padding: 50px 0px;
  width: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
}

.main-section-s1-text-con {
  height: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.main-section-s1 a {
  color: #cedb2d;
  font-size: 16px;
  font-weight: bold;
}
.main-section-s1 a[name="talktous"] {
  transform: rotate(-90deg);
  margin-top: 100px;
  display: inline-block;
}

.main-section-s2 {
  width: 90%;
  // background-color: cadetblue;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.en-center {
  margin: 10% auto auto 20%;
}
.ku-center {
  margin: 10% 20% auto auto;
}
@media (max-width: 1024px) and (max-height: 1366px) {
  .en-center {
    margin: 35% auto auto 20%;
  }
  .ku-center {
    margin: 35% 20% auto auto;
  }
}

.main-section-s2-con {
  width: 50%;
  text-align: center;
}

.main-section-s2-title-con {
  margin-bottom: 50px;
}
.main-section-s2-title-con h1 {
  font-size: 66px;
}

.main-section-s2-scrollcon {
  text-align: center;
  padding-top: 50px;
}
// media query

@media (max-width: 800px) {
  .main-section-s1 {
    display: none;
  }
  .main-section-s2 {
    width: 100%;
  }
  .main-section-s2-con {
    margin: 0;
    width: 100%;
    padding: 0px 24%;
  }
}
@media (max-width: 768px) {
  .main-section-s2-title-con h1 {
    font-size: 46px;
  }
}
@media (max-width: 625px) {
  .main-section-s2-title-con h1 {
    font-size: 36px;
    color: #cedb2d;
  }
  .main-section-s2-con {
    margin: 0;
    width: 100%;
    padding: 0px 12%;
  }
  .main-section-s2-scrollcon a {
    padding: 12px 24px;
    font-size: 14px;
  }
}
@media (max-width: 525px) {
  .main-section-s2-title-con h1 {
    font-size: 32px;
  }
}
</style>
